// ⚠️ AUTO-GENERATED FILE - DO NOT MODIFY MANUALLY
    // This file was generated by the DTO generator script.
    // Any changes will be overwritten during the next build.

    export enum CostReviewOperationResult {
  Failure = 0,
  Success = 1,
  EmailSendingFailure = 2,
  GOCRestrictionApplicable = 3,
  EstimateNoLongerCheckedOut = 4,
  InvalidCostReviewer = 5,
  ForcePublishFailure = 6,
}
